import React from 'react';

const NonAuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <React.Fragment>{children}</React.Fragment>
  );
}

export default NonAuthLayout;
